var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgRedAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#FEF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 56C46 54.8954 46.8954 54 48 54H48.02C49.1246 54 50.02 54.8954 50.02 56C50.02 57.1046 49.1246 58 48.02 58H48C46.8954 58 46 57.1046 46 56Z",
    fill: "#F06464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 40C50 38.8954 49.1046 38 48 38C46.8954 38 46 38.8954 46 40V48C46 49.1046 46.8954 50 48 50C49.1046 50 50 49.1046 50 48V40Z",
    fill: "#F06464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 48C26 35.8497 35.8497 26 48 26C60.1503 26 70 35.8497 70 48C70 60.1503 60.1503 70 48 70C35.8497 70 26 60.1503 26 48ZM48 30C38.0589 30 30 38.0589 30 48C30 57.9411 38.0589 66 48 66C57.9411 66 66 57.9411 66 48C66 38.0589 57.9411 30 48 30Z",
    fill: "#F06464"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/red-alert.2410efb103fb51186a2029e1c66fafda.svg";
export { ForwardRef as ReactComponent };